import { Link } from '@reach/router';
import { getRedirectedUrl } from 'origin_response_handler';
import * as React from 'react';
import { MARKET } from '../../config/browser';
import { SuperLinkProps } from './SuperLink.props';

export const SuperLink = (props: SuperLinkProps) => {
  const { children, getProps, target, to, ...rest } = props;
  const toChk = getRedirectedUrl(`${to}`, MARKET);
  const toPath = toChk === to ? to : toChk;

  return toPath.match(/^(http|mailto:)/i) ? (
    // Exclude any Link-specific attributes to avoid React warnings
    <a href={toPath} target={target} {...rest}>
      {children}
    </a>
  ) : (
    // Exclude `target` to avoid having Firefox prioritize opening a new window/tab over switching to route
    <Link getProps={getProps} to={toPath} {...rest}>
      {children}
    </Link>
  );
};
